export enum ApplicationDetailsTabs {
  Settings = 'settings',
  Roles = 'roles',
  Logs = 'logs',
  Branding = 'branding',
  Permissions = 'permissions',
}

export enum ApiResourceDetailsTabs {
  Permissions = 'permissions',
  General = 'general',
}

export enum ConnectorsTabs {
  Passwordless = 'passwordless',
  Social = 'social',
}

export enum WebhookDetailsTabs {
  Settings = 'settings',
  RecentRequests = 'recent-requests',
}

export enum UserDetailsTabs {
  Settings = 'settings',
  Roles = 'roles',
  Logs = 'logs',
  Organizations = 'organizations',
}

export enum RoleDetailsTabs {
  Permissions = 'permissions',
  Users = 'users',
  M2mApps = 'machine-to-machine-apps',
  General = 'general',
}

export enum TenantSettingsTabs {
  Settings = 'settings',
  Members = 'members',
  Domains = 'domains',
  Subscription = 'subscription',
  BillingHistory = 'billing-history',
}

export enum EnterpriseSsoDetailsTabs {
  Connection = 'connection',
  Experience = 'experience',
}

export enum OrganizationTemplateTabs {
  OrganizationRoles = 'organization-roles',
  OrganizationPermissions = 'organization-permissions',
}

export enum OrganizationRoleDetailsTabs {
  Permissions = 'permissions',
  General = 'general',
}
